const page = `

{settings}
document.title: Tidigare flygkrascher med Airbus A320
og.title: Tidigare flygkrascher med Airbus A320
og.image: http://www.svtstatic.se/cms-image/cachable_image/1463641931/nyheter/utrikes/article8620594.svt/ALTERNATES/large/egyptair-karta-jpg
og.description: SVT kartlägger tidigare olyckor med Airbus A320
og.url: http://pejl.svt.se/airbus-a320/
siteCatalyst.name: airbus-a320
siteCatalyst.category: lyxartikel
{}

[+page]
rubrik: Tidigare flygkrascher med Airbus A320
{.iframe}
src: https://robinlinderborg.cartodb.com/viz/55bcae5e-1dae-11e6-b0e1-0e31c9be1b51/embed_map
credit:Källa: [Aviation Safety Network | https://aviation-safety.net/ ]
{}

ingress: Airbus A320 är ett av världens vanligaste flygplanstyper när det gäller medelstora plan, endast Boeing 737 har sålts i fler exemplar. Trots att det är ett beprövat ”var mans plan” har ett antal dödliga olyckor inträffat under årens lopp.

video:8627068

Pilotmisstag, dåligt väder, tekniska fel men också utvidgat självmord från pilotens sida hör till orsakerna bakom krascherna med dödlig utgång på 2000-talet när det gäller plantypen.

mellanrubrik:[23 aug 2000|tid]
En Airbus A320-212 från Gulf Air kraschar i Persiska viken under en nattlig inflygning till Bahrains flygplats. Samtliga 143 passagerare samt besättningen omkommer. Planet kom in i landningen i för hög hastighet och kraschade med nosen först.

mellanrubrik:[3 maj 2006|tid]
Armeniska flygbolaget Armavias Airbus A320-211, på väg från Jerevan till Sotchi i Ryssland,  kraschar i Svarta havet efter att piloten nekats att landa  på grund av dåligt väder. 113 passagerare samt besättningen omkommer.

mellanrubrik:[17 juli 2007|tid]
Brasilianska TAM Airlines Airbus A320-233 på en inrikesflygning från Porto Alegre till São Paulo stannar inte på landningsbanan utan kraschar in i en flygplatsbyggnad med intilliggande tankställe. 187 människor ombord dör samt tolv på marken. Utredningen visar på pilotfel. Olyckan är den dödligaste med plantypen någonsin.

mellanrubrik: [30 maj 2008|tid]
Salvadoranska TACA Airlines Airbus A320-233 på väg från San Salvador till Miami i USA fortsätter efter att landningsbanan tagit slut i Tegucigalpa, Honduras. Fem personer ombord omkommer, två på marken. Anledning: pilotfel.

mellanrubrik: [27 november 2008|tid]
Tyska XL Airways A320-323 tappar höjd i låg hastighet under en testflygning från Frankrike med följd att piloten förlorar kontrollen och kraschar i havet utanför den sydfranska kusten. Alla sju ombord dör.

mellanrubrik: [28 december 2014|tid]
Indonesiska Air Asias Airbus 320-216, på väg från Surabaya till Singapore, kraschar i Javasjön utanför Borneo efter att ha förlorat höjd under en åskstorm på grund av tekniskt fel. Besättningen ignorerade rekommenderade nödåtgärder vilket bidrog  till olyckan. Alla 162 ombord omkom.

mellanrubrik: [24 mars 2015|tid]
Germanwings A320-211, på väg från Barcelona till Düsseldorf, kraschar in i en bergvägg i Franska alperna. 144 passagerare, bland dem en skolklass, samt sex besättningsmän dör. Det visar sig att andrepiloten Andreas Lubitz, som tidigare haft psykiska problem, medvetet kraschat planet.



linje:
text: Text: [Katri Svarfvar | strong], [katri.artta-svarfvar@svt.se | mailto:katri.artta-svarfvar@svt.se]
Mer från SVT Pejl: [ svt.se/pejl | http://www.svt.se/pejl/ | target:_self ]


{.sharebuttons}
title:Tidigare flygkrascher med Airbus A320
url:http://pejl.svt.se/airbus-a320/
{}

[]
`;

export default page;





/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/flight.js
 **/